import { render, staticRenderFns } from "./tableProductsDraft.vue?vue&type=template&id=2801f968&scoped=true"
import script from "./tableProductsDraft.vue?vue&type=script&lang=js"
export * from "./tableProductsDraft.vue?vue&type=script&lang=js"
import style0 from "./tableProductsDraft.vue?vue&type=style&index=0&id=2801f968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2801f968",
  null
  
)

export default component.exports